import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

/**
 * Stripe Checkout cancel-return page.
 *
 * Stripe redirects here with `?booking_id=…` when the visitor cancels
 * out of checkout. The booking still exists in `awaiting_payment` state
 * — we surface a quick "no charge made" message and a retry button.
 *
 * Cleanup of stale awaiting_payment bookings is handled by a future
 * cron (not in this batch — for now they sit until the host cancels
 * them or the slot fills).
 */
export default function PaymentCanceled() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-10 bg-white">
      <div className="bloq-card p-10 max-w-xl w-full text-center" data-testid="pay-canceled">
        <XCircle className="w-12 h-12 mx-auto text-[#b45309] mb-3" />
        <h1 className="bloq-headline text-3xl mb-2">Payment canceled</h1>
        <p className="text-sm text-[#4a4a52] mb-6">
          You closed the Stripe checkout without completing payment. <strong>No charge was made.</strong>
        </p>
        <p className="text-xs text-[#82828c] mb-6">
          {bookingId
            ? "Your booking is held briefly. If you want to retry, please book a fresh time slot — the original hold will be released automatically."
            : "If you'd like to try again, head back to the host's booking page."}
        </p>
        <Link to="/" className="bloq-btn-secondary inline-flex items-center" data-testid="pay-canceled-home">
          Back to home
        </Link>
      </div>
    </div>
  );
}
